import { BlastEvent, SimulationConfig } from '@/types';
import { drawBlastShape } from '@/logic/break/BreakUtils';
import { registerBlastAnimation } from './BlastAnimationRegistry';

export const RingExpandAnimation = (
  ctx: CanvasRenderingContext2D,
  e: BlastEvent,
  config: SimulationConfig,
  progress: number
) => {
  const easedProgress = 1 - Math.pow(1 - progress, 4);
  drawBlastShape(ctx, e, e.maxRadius * (1 + easedProgress));
  ctx.lineWidth = 40 * (1 - progress);
  ctx.stroke();
};

registerBlastAnimation('RING_EXPAND', RingExpandAnimation);
